import React from "react";
import PropTypes from "prop-types";
import { Tooltip } from "primereact/tooltip";
import { useDrawingColorStore } from "~/store/drawingColorStore";

const ColorInput = ({ viewMode = "grid" }) => {
  const currentColor = useDrawingColorStore((state) => state.currentColor);
  const setCurrentColor = useDrawingColorStore(
    (state) => state.setCurrentColor,
  );

  const handleColorChange = (e) => {
    console.log(
      "🎨 ColorInput.handleColorChange - new color selected:",
      e.target.value,
    );
    setCurrentColor(e.target.value);
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: viewMode === "grid" ? "center" : "flex-start",
        width: "100%",
        height: "26px",
        minHeight: "26px",
        maxHeight: "26px",
        position: "relative",
        borderRadius: "6px",
        overflow: viewMode === "grid" ? "hidden" : "visible",
        border: "2px solid transparent",
        flexShrink: 0,
        gap: viewMode === "list" ? "8px" : "0",
        padding: viewMode === "list" ? "0px 8px" : "2px",
        boxSizing: "border-box",
      }}
      id="drawing-color-input"
      data-pr-tooltip={viewMode === "grid" ? "Cor do desenho" : undefined}
    >
      <div
        style={{
          width: "18px",
          height: "18px",
          minWidth: "18px",
          borderRadius: "4px",
          overflow: "hidden",
          flexShrink: 0,
        }}
      >
        <input
          type="color"
          value={currentColor}
          onChange={handleColorChange}
          style={{
            width: "100%",
            height: "100%",
            border: "none",
            background: "none",
            padding: 0,
            cursor: "pointer",
          }}
          aria-label="Selecionar cor de desenho"
          data-evo-id="colorinput-input-drawing-color"
        />
      </div>
      {viewMode === "list" && (
        <span
          style={{
            fontSize: "12px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            flex: 1,
            color: "var(--text-color)",
            textAlign: "left",
          }}
        >
          Cor do Desenho
        </span>
      )}
      {viewMode === "grid" && <Tooltip target="#drawing-color-input" />}
    </div>
  );
};

ColorInput.propTypes = {
  viewMode: PropTypes.oneOf(["grid", "list"]),
};

export default ColorInput;
